export default __webpack_public_path__ + "static/media/vase-desk.2e821eff.png";